import { Account, AccountKycAml, KycAmlFailureResolution, KycAmlRollupStatus } from '@arrived/models';

import { BrokerageAccountSetupState } from '../../constants';

export function getBrokerageAccountSetupState(account?: Account, accountKycAml?: AccountKycAml) {
  if (!account) {
    return BrokerageAccountSetupState.CREATE_ACCOUNT;
  }

  if (!accountKycAml) {
    return BrokerageAccountSetupState.KYC_NOT_RUN;
  }

  const { kycAmlRollupStatus, kycAmlFailureResolution } = accountKycAml;

  const failureResolution = () => {
    const find = kycAmlFailureResolution.find(
      (r) =>
        r === KycAmlFailureResolution.PENDING_REVIEW ||
        r === KycAmlFailureResolution.NEED_DOC_UPLOAD ||
        r === KycAmlFailureResolution.NEED_SSN_UPDATE
    );

    if (!find) {
      return BrokerageAccountSetupState.REJECTED;
    }

    return {
      [KycAmlFailureResolution.PENDING_REVIEW]: BrokerageAccountSetupState.PENDING_VERIFICATION,
      [KycAmlFailureResolution.NEED_DOC_UPLOAD]: BrokerageAccountSetupState.UPLOAD_DOCS,
      [KycAmlFailureResolution.NEED_SSN_UPDATE]: BrokerageAccountSetupState.UPDATE_SSN,
    }[find];
  };

  return {
    [KycAmlRollupStatus.PENDING]: BrokerageAccountSetupState.KYC_NOT_RUN,
    [KycAmlRollupStatus.PENDING_SYNC]: BrokerageAccountSetupState.KYC_PENDING_SYNC,
    [KycAmlRollupStatus.PASS]: BrokerageAccountSetupState.COMPLETED,
    [KycAmlRollupStatus.FAIL]: failureResolution(),
  }[kycAmlRollupStatus];
}
